import countryList from '@/config/country';
import {
  couponRecommend,
  officialPayInfo,
  officialPayChannel,
  coinList,
  orderInit,
  rechargeResult,
  rechargeAward
} from '@/services/api';

const report = {
  namespace: 'recharge',
  state: {
    rechargeList: [],
    areaDefaultCountry: '',
    userInfo: {},
    allCountryList: [],
    tierList: [],
    coinNum: 0
  },
  reducers: {
    updateChannels(state, { payload = [] }) {
      const temp = [];
      payload.forEach(item => {
        const country = countryList.find(val => val.alpha2Code == item.country);
        temp.push({
          ...item,
          ...country
        });
      });
      return {
        ...state,
        coutryList: temp
      };
    },
    updateInfo(state, { payload }) {
      // const temp = [];
      const allCountryList = [];
      payload?.countryListBackData?.forEach(item => {
        const country = countryList.find(val => val.alpha2Code == item);
        //开始allCountryList为空，所以会全部push进去，找到对应的配置后，进行obj属性合并
        if (!allCountryList.find(ele => ele.alpha2Code == item.country)) {
          allCountryList.push({
            ...country
          });
        }
        // temp.push({
        //   ...item,
        //   ...country
        // });
      });
      console.log('payload', payload);
      return {
        ...state,
        userInfo: payload?.userInfo,
        coinNum: payload?.coinNum,
        // payChannelList: temp,
        allCountryList,
        isExpired: payload?.isExpired
      };
    },
    updateTierList(state, { payload }) {
      return {
        ...state,
        tierList: payload || []
      };
    }
  },
  effects: {
    *rechargeResult({ payload }, { call }) {
      const { data } = yield call(rechargeResult, payload);
      return data;
    },
    *couponRecommend({ payload }, { call }) {
      const { data } = yield call(couponRecommend, payload);
      return data || {};
    },
    *orderInit({ payload }, { call }) {
      const { data } = yield call(orderInit, payload);
      return data;
    },
    *coinList({ payload }, { call }) {
      const { data } = yield call(coinList, payload);
      return data;
    },
    *officialPayInfo({ payload }, { call, put }) {
      //返回数据data
      const { data = {}, error } = yield call(officialPayInfo, payload);
      //数据解构后返回给updateInfo
      const { userInfo, countryList: countryListBackData, isExpired, coinNum } = data || {};

      yield put({
        type: 'updateInfo',
        payload: {
          userInfo,
          // payChannelList,
          countryListBackData,
          isExpired,
          coinNum
        }
      });

      if (error) {
        return false;
      }

      // 返回包含 userInfo 的数据
      return {
        userInfo,
        coinNum,
        // payChannelList,
        isExpired,
        countryListBackData
      };
    },
    *officialPayChannel({ payload }, { call, put }) {
      const { data } = yield call(officialPayChannel, payload);

      // 处理 tierList 数据 - data 就是整个数组
      if (Array.isArray(data)) {
        const tierList = data?.map(item => ({
          coinNum: item.coinNum,
          payChannelList: item.payChannelList || []
        }));

        yield put({
          type: 'updateTierList',
          payload: tierList
        });
      }

      return data;
    },
    *rechargeAward({ payload }, { call }) {
      const { data } = yield call(rechargeAward, payload);
      return data;
    }
  }
};

export default report;
